import { PartyLedger } from "@/components/shared/party-ledger";
import { useClientLedger, usePostClientAdjustment } from "@/features/clients/api";
import { useClientId } from "@/features/clients/detail/use-client-id";

export function ClientLedgerPage() {
  const clientId = useClientId();
  const { data: rows = [], isLoading } = useClientLedger(clientId);
  const post = usePostClientAdjustment(clientId);

  return (
    <PartyLedger
      partyLabel="client"
      partyId={clientId}
      balanceHint="What this customer owes you. Invoices increase to-receive; receipts and credit notes reduce it."
      rows={rows}
      isLoading={isLoading}
      posting={post.isPending}
      onPostAdjustment={(values) => post.mutateAsync(values)}
    />
  );
}
